export class AzureStorageAccounts {
    'storageAccounts';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "storageAccounts",
            "baseName": "storageAccounts",
            "type": "Array<AzureStorageAccount>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureStorageAccounts.attributeTypeMap;
    }
    constructor() {
    }
}
